import { format } from 'date-fns';
import { capitalize } from 'lodash';
import { memo } from 'react';
import { useSelector } from 'react-redux';

import { CloudUploadIcon } from '@air/design-icons';
import { MONTH_DAY_YEAR_FORMAT, parseAirDateToISO } from '@air/utilities';
import { SOURCE_MAP } from '@air/utils-clips';

import { InfoPanelDetailsSection } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection';
import { InfoPanelDetailValue } from '~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue';
import {
  centralizedClipCreatedDateSelector,
  centralizedClipOwnerSelector,
  centralizedClipSourceSelector,
} from '~/store/centralizedClip/selectors';

export const InfoPanelUploadedBy = memo(() => {
  const owner = useSelector(centralizedClipOwnerSelector);
  const source = useSelector(centralizedClipSourceSelector);
  const uploadedAt = useSelector(centralizedClipCreatedDateSelector);

  return (
    <InfoPanelDetailsSection Icon={CloudUploadIcon} title="Uploaded">
      <InfoPanelDetailValue
        value={format(parseAirDateToISO(uploadedAt), MONTH_DAY_YEAR_FORMAT)}
        additionalInfo={`Uploaded via ${SOURCE_MAP?.[source] ?? capitalize(source)} by ${owner.ownerName}`}
      />
    </InfoPanelDetailsSection>
  );
});

InfoPanelUploadedBy.displayName = 'InfoPanelUploadedBy';
